import { TranscriptSchema } from "../../schemas/transcript";
export function parseTxtTranscript(content) {
    const lines = content
        .split(/\r?\n/)
        .map(l => l.trim())
        .filter(Boolean);
    // inline: role prefix on same line
    const INLINE = /^(clinician|doctor|dr|patient)\s*:\s*(.+)$/i;
    // header: line that just sets the speaker (can have trailing id like "DOCTOR A074")
    const HEADER = /^(clinician|doctor|dr|patient)\b(?!\s*:)/i;
    const entries = [];
    let current = "other";
    const roleToSpeaker = (roleRaw) => {
        const r = roleRaw.toLowerCase();
        return r === "patient" ? "patient" : "clinician"; // clinician, doctor, dr → clinician
    };
    for (const line of lines) {
        const mInline = line.match(INLINE);
        if (mInline) {
            const [, role, text] = mInline;
            entries.push({ speaker: roleToSpeaker(role), text: text.trim() });
            continue;
        }
        const mHeader = line.match(HEADER);
        if (mHeader) {
            current = roleToSpeaker(mHeader[1]);
            continue; // header line does not carry content
        }
        // free text: attribute to current speaker if set, else "other"
        entries.push({ speaker: current, text: line });
    }
    if (entries.length === 0) {
        const fallbackText = content.trim();
        if (!fallbackText) {
            return TranscriptSchema.parse({ entries });
        }
        return TranscriptSchema.parse({
            entries: [{ speaker: "other", text: fallbackText }],
        });
    }
    try {
        return TranscriptSchema.parse({ entries });
    }
    catch {
        const fallbackText = content.trim();
        if (!fallbackText) {
            throw new Error("Failed to parse transcript");
        }
        return TranscriptSchema.parse({
            entries: [{ speaker: "other", text: fallbackText }],
        });
    }
}
